import { render, staticRenderFns } from "./StudentForm.vue?vue&type=template&id=4adedbb0&scoped=true&"
import script from "./StudentForm.vue?vue&type=script&lang=ts&"
export * from "./StudentForm.vue?vue&type=script&lang=ts&"
import style0 from "./StudentForm.vue?vue&type=style&index=0&id=4adedbb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adedbb0",
  null
  
)

export default component.exports